export default (str: string, maxlength: number, ellipsis?: string) =>
  str?.length > 0 && str.length > maxlength
    ? str.slice(0, maxlength - 1) + (ellipsis || "...")
    : str;
